export const FirebaseConfig = {
	"projectId": "ridein-app-b0d3b",
	"appId": "1:580654520311:web:08f765c8dd7e7525dc40f2",
	"databaseURL": "https://ridein-app-b0d3b-default-rtdb.firebaseio.com",
	"storageBucket": "ridein-app-b0d3b.firebasestorage.app",
	"apiKey": "AIzaSyA_kjKEJBBOnx8sfM6FvBKVyPVGPnaI9uU",
	"authDomain": "ridein-app-b0d3b.firebaseapp.com",
	"messagingSenderId": "580654520311",
	"measurementId": "G-8QE3YH3CP1",
	"projectNumber": "580654520311",
	"version": "2"
};